<template>
  <recipe-label
    :value="difficultyText"
    icon="far fa-smile-wink"
    v-if="difficultyText"
  />
</template>

<script>
import RecipeLabel from "./RecipeLabel";

const DIFFICULTIES = [
  "triviální",
  "snadné",
  "středně těžké",
  "těžké",
  "obtížné"
];

export default {
  name: "RecipeLabelDifficulty",
  components: { RecipeLabel },
  computed: {
    difficultyText() {
      if (this.difficulty && this.difficulty >= 1 && this.difficulty <= 5) {
        return DIFFICULTIES[this.difficulty];
      } else {
        return null;
      }
    }
  },
  props: {
    difficulty: {
      type: Number,
      default: null
    }
  }
};
</script>
